<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header card-header-danger">
          <h4 class="card-title">{{ isEditMode ? 'Edit Diary Entry' : 'Add Diary Entry' }}</h4>
          <p class="card-category">Complete diary details</p>
        </div>
        <div class="card-body">
          <form [formGroup]="diaryForm" (ngSubmit)="submitForm()">
            <div class="row">
              <!-- Case -->
              <div class="col-md-12">
                <mat-form-field class="w-100">
                  <mat-label>Case</mat-label>
                  <mat-select formControlName="caseId" required>
                    <mat-option *ngFor="let caseItem of cases" [value]="caseItem.id">
                      {{ caseItem.caseNumber }}/{{ caseItem.year }} - {{ caseItem.client?.fullName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <!-- Hearing Date -->
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <mat-label>Hearing Date</mat-label>
                  <input matInput [matDatepicker]="hearingPicker" formControlName="hearingDate" placeholder="Choose hearing date" />
                  <mat-datepicker-toggle matSuffix [for]="hearingPicker"></mat-datepicker-toggle>
                  <mat-datepicker #hearingPicker></mat-datepicker>
                </mat-form-field>
              </div>

              <!-- Status -->
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <mat-label>Status</mat-label>
                  <mat-select formControlName="status">
                    <mat-option value="Pending">Pending</mat-option>
                    <mat-option value="Completed">Completed</mat-option>
                    <mat-option value="Adjourned">Adjourned</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Reminder Set -->
              <div class="col-md-4 d-flex align-items-center">
                <mat-checkbox formControlName="reminderSet">Set Reminder</mat-checkbox>
              </div>
            </div>

            <div class="row" *ngIf="diaryForm.get('reminderSet')?.value">
              <!-- Reminder DateTime -->
              <div class="col-md-6">
                <mat-form-field class="w-100">
                  <mat-label>Reminder Date & Time</mat-label>
                  <input matInput type="datetime-local" formControlName="reminderDateTime" />
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <!-- Notes -->
              <div class="col-md-12">
                <mat-form-field class="w-100">
                  <mat-label>Notes</mat-label>
                  <textarea matInput formControlName="notes" placeholder="Enter any notes here"></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <app-file-uploader [folder]="'diary'"></app-file-uploader>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-12 text-end">
                <button mat-button type="button" class="btn btn-secondary me-2" (click)="onCancel()">
                  Cancel
                </button>
                <button mat-raised-button color="danger" type="submit" class="btn btn-danger" [disabled]="isSubmited" (click)="isSubmited = true">
                  {{ isEditMode ? 'Update Diary Entry' : 'Add Diary Entry' }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
